/* globals define */
/*
  Purpose:
    - Simple UI controller for the expansion and contraction of the search field

  Dependencies:
    - jQuery
    - THD Namespace
*/

(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.search.lite', ['jquery', 'global.namespace', 'header.search.core', 'utils.url', 'MobileTypeahead'],
     function load(jQuery, THD, headerSearchCore, utilsUrl, MobileTypeahead) {
      return factory(root, jQuery, THD, headerSearchCore, utilsUrl, MobileTypeahead);
    });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /* eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.search = factory(root, jQuery, THD.Global.TypeAhead, headerSearchCore, utilsUrl, MobileTypeahead);
    /* eslint-enable*/
  }
})(this, function factory(root, $, THD, headerSearchCore, utilsUrl, MobileTypeahead) {
  var search = {};
  var privateMethods = {};

  privateMethods.getSearchValFromUrl = function getSearchValFromUrl(defaultTerm, window) {
	var docUrl = window.document.URL;
	var searchUrl = window.location.pathname;
    var isBrowse = (docUrl.indexOf('/Ntt-') > -1); // checks to see if category selected
    var browseRegEx = /NTT-(.*?)\?/i;
    var searchRegEx = /^\/s\/(.*)$/;
    var regex = (isBrowse) ? browseRegEx : searchRegEx;
    var searchMatch = new RegExp(regex).test(searchUrl);
    return (searchMatch) ? decodeURIComponent(decodeURIComponent(searchUrl.match(regex)[1])) : defaultTerm;
  };

  //sets the protocol
  privateMethods.getSearchVal = function getSearchVal() {
    var searchTerm = '';
    var keyword = utilsUrl.get({ lookupParm: 'keyword' });
    var searchRedirect = utilsUrl.get({ lookupParm: 'searchRedirect' });
    var wcsParmCheck = (keyword) ? keyword : searchRedirect;

    // final check for wcs style urls
    if(wcsParmCheck) {
    searchTerm = wcsParmCheck;
    }else{
    searchTerm = privateMethods.getSearchValFromUrl(searchTerm, window);
    }
    searchTerm = searchTerm.replace(/\+/g, ' ');
    return searchTerm;
  };


  search.init = function init() {
    var $typeAheadInput = $('#headerSearch');
    var $typeAheadContainer = $('#typeAheadContainer');
    var $historyContainer = $('#searchHistory');
    var isSearchClicked = false;
    /* Removed the logic to fetch the search term from global variable THD_SEARCH_DEFAULT_KEYWORD
     * We will be using the same logic as desktop to fetch the value.
     * var defaultValue = (typeof THD_SEARCH_DEFAULT_KEYWORD !== 'undefined') ? THD_SEARCH_DEFAULT_KEYWORD : '';*/
    var defaultValue = privateMethods.getSearchVal();
    // if user is already focused on search then activate searchbox
    headerSearchCore.checkSearchFocus();

    // Set the input field and container to populate
    search.MobileTypeahead = new MobileTypeahead({
      input: $typeAheadInput,
      defaultValue: defaultValue
    });

    $typeAheadInput.on('click', function(e){
      if(!isSearchClicked){
      const input = document.getElementById('headerSearch');
      input.focus();
      input.setSelectionRange(0, 9999);
      }
      isSearchClicked = true;
    });

    $(document)
      .on('click touchend', '.SearchBox__cover', headerSearchCore.openSearch)
      .on('click touchend', '.SearchBox__input', headerSearchCore.openSearch)
      .on('focus', '.SearchBox__button', headerSearchCore.openSearch)
      .on('blur', '.SearchBox__button', headerSearchCore.closeSearch)
      .on('click touchend', '.SearchBox__cancel', headerSearchCore.clearSearchField)
      .on('click', '#js-barcode-scanner', headerSearchCore.openScanner)
      .on('click', '#js-close-barcode-scanner', headerSearchCore.clearSearchField);
    return this;
  };

  // this method is for unit test cases.
  search.getPrivateMethods = function getPrivateMethods() {
	    return privateMethods;
  };

  return search;
});
